import { useIsPeopleUnlockButtonLoading } from '@aibees/elephant/components/people-unlock/hooks/use-is-people-unlock-button-loading';
import { ProfileDetailsNoData } from '@aibees/elephant/components/profile-details-no-data';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { PersonContactDetailsItem } from '@aibees/elephant/feature/search-table-people/types';
import { Scrollbar } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { ContactDetailItemHeader } from '../../../contact-detail-item-header';
import { useContactDetailsState } from '../../context';
import { useSetSeemoreVisibility } from '../../hooks/use-set-seemore-visibility';
import * as EXTERNALSX from '../../sx';
import { doesContactDetailHaveUpdate } from '../../utils';
import { PublicationsItem } from './components/publications-item';
import * as SX from './sx';
import type { PublicationsProps as Props } from './types';

export const Publications = memo(
  ({ className, itemsLimit, setShowSeeMore }: Props) => {
    const { api } = usePersonReadDataContext();
    const { loadingContactDetails } = useIsPeopleUnlockButtonLoading(api.data);
    const { unlocked, isPopoverType } = useContactDetailsState();
    const hasUpdate = doesContactDetailHaveUpdate(
      PersonContactDetailsItem.PUBLICATIONS,
      api.data
    );

    useSetSeemoreVisibility(
      setShowSeeMore,
      itemsLimit,
      api.data?.publications?.length
    );

    const content = (
      <Stack direction="column" gap={1}>
        {hasUpdate && api.data?.publications?.[0] && (
          <div
            key={-1}
            style={{
              filter: 'blur(4px)',
            }}
            onClick={(e) => e.preventDefault()}
          >
            <PublicationsItem item={api.data?.publications?.[0]} index={-1} />
          </div>
        )}
        {api.data?.publications?.map((item, index) => {
          if (!!itemsLimit && index >= itemsLimit) return null;
          return (
            <div key={index}>
              <PublicationsItem item={item} index={index} />
            </div>
          );
        })}
      </Stack>
    );

    return (
      <Box className={classnames('Publications', className)} sx={SX.root}>
        <ContactDetailItemHeader
          title="Publications"
          count={api.data?.publications?.length ?? 0}
        />

        {!unlocked || loadingContactDetails ? (
          <ProfileDetailsNoData />
        ) : isPopoverType ? (
          <Scrollbar sx={EXTERNALSX.generalProfileDetailsScrollbar}>
            {content}
          </Scrollbar>
        ) : (
          content
        )}
      </Box>
    );
  }
);

Publications.displayName = 'Publications';
